// eslint-disable-next-line no-shadow
export enum TypeOfTableData {
  DISPLAY = 'display',
  OPPORTUNITY_FLAG = 'opportunityflag',
  INPUT = 'input',
  OUTPUT = 'output',
  ACTION = 'action',
  LEGEND_FLAG = 'legendflag',
  DT_PBI_IFRAME_TYPE_1 = 'DT_PBI_IFRAME_TYPE_1',
  ICON_TYPE = 'ICON_TYPE'
}

// eslint-disable-next-line no-shadow
export enum ToggleKeys {
  RETAILER = 'retailer',
  OWN = 'own'
}

// eslint-disable-next-line no-shadow
export enum InputType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  PERCENTAGE = 'PERCENTAGE',
  DATETIME = 'DATETIME',
  DATETIMEHOUR = 'DATETIMEHOUR',
  CHECKBOX = 'CHECKBOX',
  SINGLESELECT_DROPDOWN = 'SINGLESELECT_DROPDOWN',
  CHECKBOX_LABEL = 'CHECKBOX_LABEL',
  DECIMAL = 'DECIMAL',
  LEGEND_FLAG = 'LEGENDFLAG',
  TEXT = 'TEXT',
  ACTION = 'ACTION',
  COMMENT_CARD = 'COMMENT_CARD',
  DT_PBI_IFRAME_TYPE_1 = 'DT_PBI_IFRAME_TYPE_1',
  PH_RECOMMENDATION_TYPE = 'PH_RECOMMENDATION_TYPE',
  OVERWRITE = 'OVERWRITE',
  PRICE_THRESHOLD_TYPE = 'PRICE_THRESHOLD_TYPE',
   NOTE = 'NOTE',
  DELETECOLUMN = 'DELETECOLUMN',
}

export interface ShowEditedToggle {
  enabled: boolean;
  label: string;
}
export interface IComponentVisibilityMetadata {
  enabled: boolean;
  label: string;
}

export interface MetaData {
  enable_parent_level_inputs: boolean;
  output_section_label: string;
}

export interface ISimResultToggleOption {
  alias: string;
  pk_id: number;
  order?: number;
  name: string;
}

export interface ISimulationResultToggleMetadata {
  metadata?: IComponentVisibilityMetadata[];
  data?: {
    [key: string]: ISimResultToggleOption;
  };
}

export interface ToggleOptions {
  name: string;
  pk_id: number;
  alias: string;
  toggle_tag: string;
  metadata: any;
  order?: number;
}

export interface HeaderOptions {
  parent_field: string;
  toggle_tag?: string[];
  output_toggle_tag?: any[];
  alias: string;
  section: string;
  order: number;
  is_sticky_column: boolean;
  has_border?: boolean;
  default_value?: string | number | boolean;
  is_visible: boolean;
  is_price_threshold_eligible?: boolean;
  is_global_input_enable: boolean;
  is_cf_enable: boolean;
  is_info_enable: boolean;
  info_details: string;
  is_input_enable: boolean;
  prefix_label: string;
  suffix_label: string;
  number_format: string;
  field_format: string;
  datatype: string;
  default_value_field?: string;
  is_sort_enable: boolean;
  default_sort_order: string;
  has_footer: boolean;
  formula: string;
  self_change_formula: string;
  linked_to_field: string;
  linked_to_fields?: any[];
  child_field: string;
  level?: number;
  is_part_of_payload?: boolean;
  static_values?: any;
  currency_label?: string;
  fill_color?: string;
  is_reset_needed?: boolean;
  is_forward_to_children?: boolean;
  innovation_opportunity_flag?: boolean;
  should_show_expandall?: boolean;
}

export interface Header {
  parent: HeaderOptions;
  children: any[];
}

export interface HeaderMetadata {
  is_sticky_column: boolean;
  is_visible: boolean;
  is_global_edit_visible: boolean;
  is_cf: boolean;
  is_info: boolean;
  is_part_of_payload: boolean;
  info_details: string;
  has_border?: boolean;
  is_input: boolean;
  prefix_label: string;
  suffix_label: string;
  field_number_format: string;
  field_dtype: string;
  field_type: string;
  formula: string;
  linked_to: string;
  is_sortable: boolean;
  default_sort_order: string;
  self_change_formula: string;
}

export interface Footer {
  enabled: boolean;
  label: string;
}

export interface RowData {
  parent: any;
}

interface ITableColumnDisplayMetadata {
  inputCols: Header[];
  resultCols: Header[];
}

export interface LegendMetadata {
  enabled: boolean;
  label: string;
  color: string;
}

export interface SummaryStrip {
  pk_id: number;
  created_at: string;
  updated_at: string;
  name: string;
  alias: string;
  enabled: boolean;
  is_visible: boolean;
  order: number;
  is_info_enable: boolean;
  info_details: string;
  prefix_label: string;
  suffix_label: string;
  number_format: string;
  source: number;
  module: number;
}

export interface SummaryStripModule {
  json_output_key?: string;
  value: number;
  label: string;
  suffix: string;
  children: SummaryStripModule[];
}

export interface SummaryStripData {
  internal_dt: number;
  external_dt: number;
  renovation: SummaryStripModule;
  pricing: SummaryStripModule;
  delist: SummaryStripModule;
  distribution: SummaryStripModule;
  innovation_table: SummaryStripModule;
}

export interface SummaryStripMasterData {
  metadata: SummaryStrip[];
  data: any;
  // data: SummaryStripData;
}

export interface ITableData {
  ownKPIColumnMetadata?: ITableColumnDisplayMetadata;
  retailerKPIColumnMetadata?: ITableColumnDisplayMetadata;
  metadata?: MetaData[];
  show_edited?: any;
  toggle?: ISimulationResultToggleMetadata;
  output_toggle?: ISimulationResultToggleMetadata;
  header: Header[];
  legend: {
    metadata: LegendMetadata[];
  };
  // footer: {
  //   row: any[];
  //   metadata: IComponentVisibilityMetadata;
  // };
  footer: any;
  row: any;
  externalRow?: any;
  summary_strip?: any;
  summary_strip_data?: any;
  sku_name_list?: string[];
}

// eslint-disable-next-line no-shadow
export enum TableComponent {
  PRICING = 'PRICING',
  RENOVATION = 'RENOVATION',
  INNOVATION = 'INNOVATION',
  DELIST = 'DELIST',
  PLANNER = 'PLANNER',
  SCENARIOMANAGER = 'SCENARIOMANAGER',
  POTENTIALRISK = 'POTENTIALRISK', // added for potential risks
  PPGLEVELIMPACT = 'PPGLEVELIMPACT', // added for PPG level impact
  MULTIYEARESTIMATE = 'MULTIYEARESTIMATE',
  COGS = 'COGS'
}

// eslint-disable-next-line no-shadow
export enum CHECKBOX_VALUES {
  IS_ACTIVE_FINALIZED = 'isActiveFinalized',
  IS_FINALIZED = 'isFinalized',
  IS_ARCHIVED = 'isArchived'
}

// eslint-disable-next-line no-shadow
export enum MODIFIED_ROW_INDICATOR_KEY {
  PRICING_IS_EDITED = 'pricing_is_edited',
  PRICING_IS_NOT_DEFAULT = 'pricing_is_not_default',
  PRICING_IS_USER_INPUT = 'pricing_is_user_input',
  RENOVATION_IS_EDITED = 'renovation_is_edited',
  RENOVATION_IS_NOT_DEFAULT = 'renovation_is_not_default',
  RENOVATION_IS_USER_INPUT = 'renovation_is_user_input',
  COGS_IS_EDITED = 'kpi_update_is_edited',
  COGS_IS_NOT_DEFAULT = 'kpi_update_is_not_default',
  COGS_IS_USER_INPUT = 'kpi_update_is_user_input',
  DELIST_IS_EDITED = 'delist_is_edited',
  DELIST_IS_NOT_DEFAULT = 'delist_is_not_default',
  DELIST_IS_USER_INPUT = 'delist_is_user_input'
}

export enum ACTION_TYPE {
  DROPDOWN = 'DROPDOWN',
  CHECKBOX = 'CHECKBOX',
  NUMBER = 'NUMBER'
}
